import React from 'react';
import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import { useZustandAuth } from 'zustandStore';
import { routes, STORAGEKEY_AUTH_TOKEN } from 'config/constants';
import { getLocalStorage } from 'utils/storage';

const PublicRoute = props => {
    const { isAuthed } = useZustandAuth();
    const token = getLocalStorage(STORAGEKEY_AUTH_TOKEN);

    if (isAuthed || !!token) {
        return <Navigate to={routes.culturals}/>;
    }

    return props.children;
};

PublicRoute.propTypes = {
    children: PropTypes.element
};

export default PublicRoute;
